import {  INBOXS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import { inboxs } from "@/dev/data"




export const getAll = ({ commit },agent_id = null) => {

    let filter = "";
    if(agent_id){
        filter+=`?agent_id=${agent_id}`
    }
    const url = INBOXS_API+filter
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        console.log('data', data)
        commit(types.SET_ITEMS, data?.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)

        commit(types.SET_ITEMS,inboxs);
        commit(types.SET_CURRENT_ITEM,null)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
      
    })
}
export const getFilter = ({ commit },agent_id) => {
    const url = INBOXS_API
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)

        //Dev
        if(agent_id == 'all'){
            commit(types.SET_ITEMS,inboxs);
       }else{
            commit(types.SET_ITEMS,inboxs.filter((inbx)=>(inbx.agent_treatment_id == agent_id)));
        }
        commit(types.SET_CURRENT_ITEM,null)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
      
    })
}

export const resetData = ({ commit }) => {
    commit(types.RESET)
}



